<template>
  <div class="volume flex">
    <InputNumber
      v-model:value="volumeObj.len"
      :controls="false"
      :placeholder="$lang('长')"
      :min="1"
      :max="150"
      @change="handleChagne('len')"
      @blur="onFieldChange"
    ></InputNumber>
    <span class="x">X</span>
    <InputNumber
      v-model:value="volumeObj.width"
      :controls="false"
      :min="1"
      :max="150"
      :placeholder="$lang('宽')"
      @change="handleChagne('width')"
      @blur="onFieldChange"
    ></InputNumber>
    <span class="x">X</span>
    <InputNumber
      v-model:value="volumeObj.height"
      :controls="false"
      :min="1"
      :max="150"
      :placeholder="$lang('高')"
      @change="handleChagne('height')"
      @blur="onFieldChange"
    ></InputNumber>
    <span class="x">=</span>
    <Input v-model:value="volumeObj.volume" :controls="false" disabled :placeholder="$lang('0cm³')"></Input>
  </div>
</template>
<script lang="ts" setup>
  import { InputNumber, Form, Input } from 'ant-design-vue'
  import { ref, watch } from 'vue'
  const { onFieldChange } = Form.useInjectFormItemContext()
  const props = defineProps<{
    len: number | undefined
    width: number | undefined
    height: number | undefined
    value: Record<string, any>
  }>()
  const volumeObj = ref({
    len: props.len,
    width: props.width,
    height: props.height,
    volume: undefined as number | undefined
  })
  const types = ['len', 'width', 'height']
  const emits = defineEmits([
    'change',
    ...['len', 'width', 'height', 'value', 'volume', 'volumeWeight'].map((_) => `update:${_}`)
  ])
  const handleChagne = (type: keyof typeof volumeObj.value) => {
    emits(`update:${type}`, volumeObj.value[type])
    emits(`update:value`, volumeObj.value)
    emits('change', volumeObj.value, volumeWeight(volumeObj.value))
    emits('change', volumeObj.value, volume(volumeObj.value))
  }
  /**体积重 */
  const volumeWeight = (c: Record<string, any>) => {
    return c.width * c.height * c.len > 0 ? Number(Number((c.width * c.height * c.len) / 6000).toFixed(2)) : undefined
  }
  /**体积 */
  const volume = (c: Record<string, any>) => {
    volumeObj.value.volume =
      c.width * c.height * c.len > 0 ? Number(Number(c.width * c.height * c.len).toFixed(2)) : undefined
    return volumeObj.value.volume
  }
  watch(
    () => props.value,
    (c, p) => {
      for (let i = 0; i < types.length; i++) {
        const type = types[i]
        volumeObj.value[type] = c[type]
        emits(`update:${type}`, c[type])
      }
      /**体积重 */
      emits(`update:volumeWeight`, volumeWeight(c))
      /* 体积 */
      emits(`update:volume`, volume(c))
    },
    { deep: true }
  )
</script>
<style lang="less" scoped>
  .volume {
    .ant-input-number {
      flex: 1;
    }
    .ant-input {
      flex: 1;
    }
    .x {
      margin: 0 6px;
      color: #4c4d57;
    }
  }
</style>
